import {createSelector} from 'reselect';
import {getSystem, getTripData, getTranslations} from './store';
import {getConditionalInstantBook} from './priceDetails';
import {getBookingType, getHostType} from './listing';
import {isInBucket} from '../../universal/utils/abacusHelper';

const getContactButtonLabel = createSelector(
    [getHostType, getTranslations],
    (hostType, translations) => {
        const label = hostType.owner ? translations.contactOwner : translations.contactManager;

        return label || '';
    }
);

const getBookButtonLabel = createSelector(
    [getTranslations, getConditionalInstantBook, getBookingType],
    (translations, conditionalInstantBook, bookingType) => {
        const {
            onlineBookable,
            instantBook
        } = bookingType;

        let label;

        if (onlineBookable) {
            label = (instantBook || conditionalInstantBook) ? translations.propertyBookNow : translations.propertyRequestToBook;
        }

        return label || '';
    }
);

const getCheckAvailabilityLabel = createSelector(
    [getTranslations, getSystem, getTripData],
    (translations, system, tripData) => {
        const inBucket = isInBucket('ha_pdp_checkAvailabilityButtonThrottle');
        return inBucket && system.arrivedFromExternalSite && tripData.arrivedWithoutDates ? translations.checkAvailability : '';
    }
);

const getListingLabels = createSelector(
    [getContactButtonLabel, getBookButtonLabel, getCheckAvailabilityLabel],
    (contactButton, bookButton, checkAvailabilityButton) => {
        return {
            contactButton,
            bookButton,
            checkAvailabilityButton
        };
    }
);

export default getListingLabels;

export {
    getListingLabels,
    getCheckAvailabilityLabel,
    getContactButtonLabel,
    getBookButtonLabel
};
